import React, { useMemo } from 'react';
import { useParams } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { FRAME_TYPE_MAP } from '@/pages/benchmark/_config/constant';
import { formatFilterValues } from '@/pages/benchmark/utils/utils';
export default function MetricDetailChartService(props: any) {
  const { style, className, config, children, filterVal, filterLoading, data, dataKey = "metricDetailChart", activeTab, activeRadio, transverse = ["country"], ...resetProps } = props || {};
  const { api } = config || {};
  const { metric } = useParams<{ metric: string; }>();
  // 是否横向柱状图
  const isTransverse = transverse?.includes(activeTab?.value);
  const serviceData = useMemo(() => ({
    ...data,
    activeTab,
    activeRadio,
  }), [data, activeTab, activeRadio]);

  const formatData = (data: { metrics_list: never[]; }) => {
    const list = data?.metrics_list || [];
    const metricList = list?.map((item: any) => ({
      code: item?.[activeTab?.value],
      metrics: item?.metrics,
    }));
    return metricList;
  };

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        dataKey={dataKey}
        data={serviceData}
        filterVal={filterVal}
        filterLoading={filterLoading}
        trackData={["frameType", "activeTab", "activeRadio"]}
        beforeRequest={data => {
          const { frameType, filterVal, activeTab, activeRadio } = data;
          const by = activeTab?.value || "";
          const params = {
            filters: {
              ...formatFilterValues(filterVal),
              // genre_list: [],     // 跟后端核对该参数传为空数组
            },
            accumulation: {
              by_game: by === 'game',
              by_genre: by === 'genre',
              by_region: by === 'region',
              by_country: by === 'country',
              by_platform: by === 'platform'
            },
            metrics: [metric],
            frame_type: FRAME_TYPE_MAP[frameType],
            value_type: activeRadio?.value,
            page: 1,
            // 横向柱状图，国家展示top50
            page_size: isTransverse ? 50 : 10,
            is_page: true,
            sorted_by: metric,
            desc: true
          };
          return params;
        }}
        formatData={formatData}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(child, {
          dataKey,
          metric,
          isTransverse,
          ...resetProps
        }))}
      </Service>
    </div>
  );
}
